// extracted by mini-css-extract-plugin
export default {"head__container":"styles_head__container__+RSsQ","title__text":"styles_title__text__1qc81"};